import React, { useState } from 'react';
import './BlackberryCategory.scss';

const categoryData = [
    {
        id:1,
        categoryName:'WEDDING WEAR',
        categoryImage:'/assets/img/elnora/three.png',
        categoryTitle:'MOMENTS & MEMORIES',
        categoryDescription:'Elegant bridal gowns, lehengas, sarees, accessories, and formal wedding attire for unforgettable celebrations.',
        buttonText:"Shop Now"
    },
    {
        id:2,
        categoryName:'PARTY WEAR',
        categoryImage:'/assets/img/elnora/one.png',
        categoryTitle:'Nights to Remember',
        categoryDescription:'Trendy dresses, suits, sarees, and accessories perfect for glamorous parties and evening celebrations.',
        buttonText:"Shop Now"
    },
    {
        id:3,
        categoryName:'CASUAL WEAR',
        categoryImage:'/assets/img/elnora/two.png',
        categoryTitle:'Everyday Comforts',
        categoryDescription:'Stylish sets, dresses, and accessories designed for effortless, comfortable, and versatile daily wear.',
        buttonText:"Shop Now"
    },
    {
        id:4,
        categoryName:'FESTIVE WEAR',
        categoryImage:'/assets/img/elnora/26.png',
        categoryTitle:'Celebrate in Style',
        categoryDescription:'Vibrant dresses ,lehengas, and accessories crafted for joyful celebrations and festive occasions.',
        buttonText:"Shop Now"
    }
]

const BlackberryCategory = () => {
    const [activeTab, setActiveTab] = useState(0);

    return (
        <section className='bb-category-section'>
            <div className="bb-category-container">
                <header className="bb-category-header">

                    <div className="bb-category-header-text">
                    <h2>SHOP BY OCCASION</h2>
                    <p>Life is an Ocassion. Rise to it</p>
                    </div>

                    <div className="bb-tab-navigation">
                        {categoryData.map((category, index) => (
                            <button
                                key={category.id}
                                className={`tab ${activeTab === index ? 'active' : ''}`}
                                onClick={() => setActiveTab(index)}
                            >
                                {category.categoryName}
                            </button>
                        ))}
                    </div>
                </header>

                <div className="bb-category-grid">
                    {categoryData.map((category, index) => (
                        <div 
                            key={category.id}
                            className={`category-item ${activeTab === index ? 'active' : ''}`}
                        >
                            <div className="bb-category-content">
                                <div className="bb-text-content">
                                    <h3>{category.categoryTitle}</h3>
                                    <p>{category.categoryDescription}</p>
                                    <button className="bb-explore-btn">
                                        {category.buttonText}
                                    </button>
                                </div>
                                <div className="bb-image-wrapper">
                                    <img 
                                        src={category.categoryImage} 
                                        alt={category.categoryName} 
                                        loading="lazy"
                                    />
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default BlackberryCategory;
